export const environment = {
  production: true,
  apiUrl: "https://integration-api.we7.digital/api/",
  apiUrlVivenu: "https://vivenu-api.we7.digital/api/",
  sentryDsn: "https://21b939d8aaa62e59121b3c53ba6b3e6b@sentry.we7.digital/4",
};
